import axios from 'axios';
//
// Base configuration for axios
//https://localhost:44346/api
const apiClient = axios.create({
  //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.truvey.in/api',
   //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://localhost:44346/api', 
   baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.xprssurvey.com/api', // Replace with your API base URL
  //baseURL: process.env.REACT_APP_API_BASE_URL || 'https://xprssurveyapi.demoo4s.com/api', // Replace with your API base URL

  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Service methods
const AdminService = {
  GetCompaniesData: async (token) => {
    try {
      const response = await apiClient.post('/Admin/GetCompaniesForAdmin', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  GetUserCompanyDetails: async (token) => {
    try {
      const response = await apiClient.post('/Login/GetUserCompanyDetails', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  GetCompaniyDetailsForAdmin: async (Token, CompanyUID) => {
    try {
      const response = await apiClient.post('/Admin/GetCompaniyDetailsForAdmin', { Token, CompanyUID });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  UpdateCompanyData: async (submitFormData) => {
    const response = await apiClient.post('/Admin/UpdateCompanyProfile', submitFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    return response.data;
  },
  GetPlanDetailsIndividual: async (token) => {
    try {
      const response = await apiClient.post('/Admin/GetPlanDetailsIndividual', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  GetPlanDetailsCorporate: async (token) => {
    try {
      const response = await apiClient.post('/Admin/GetPlanDetailsCorporate', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  GetRoles: async (token) => {
    try {
      const response = await apiClient.post('/Admin/GetRoles', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  CreateCompany: async (SurveyData, AdminData, companyData) => {
    try {
      const response = await apiClient.post(
        "/Admin/CreateCompany",
        {
          Survey: SurveyData,
          AdminObj: AdminData,
          CompanyObj: companyData
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating company:", error);
      throw error;
    }
  },
  CreateUsers: async (Token, Name, Email, MobileNo, UserRole) => {
    try {
      const response = await apiClient.post("/Admin/CreateCompanyUsers", { Token, Name, Email, MobileNo, UserRole });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },
  GetCompanyUsers: async (token) => {
    try {
      const response = await apiClient.post('/Admin/GetCompanyUsers', { token });
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response);
        return error.response;
      } else {
        console.error('Error without response:', error);
        throw error;
      }
    }
  },

};

export default AdminService;
